/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum LocationContext {
  Pickup = "pickup",
  Delivery = "delivery",
  Any = "any",
}

export function instanceOfLocationContext(value: any): boolean {
  for (const key in LocationContext) {
    if (Object.prototype.hasOwnProperty.call(LocationContext, key)) {
      if (LocationContext[key as keyof typeof LocationContext] === value) {
        return true;
      }
    }
  }
  return false;
}

export function LocationContextFromJSON(json: any): LocationContext {
  return LocationContextFromJSONTyped(json, false);
}

export function LocationContextFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LocationContext {
  return json as LocationContext;
}

export function LocationContextToJSON(value?: LocationContext | null): any {
  return value as any;
}

export function LocationContextToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): LocationContext {
  return value as LocationContext;
}
